import React from 'react';
import { useFlowConfigHistory } from './useFlowConfigHistory';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/ui/accordion';
import { History } from 'lucide-react';
import { BaseFlowConfig, FlowDeviceConfig } from './useFlowConfig';
import { getExtendedAlertMessageString } from './helpers';

export interface LowLevelAlert extends BaseFlowConfig {
  config: {
    cmLimit: number;
  };
}

export interface FreezeAlert extends BaseFlowConfig {
  config: {
    temp: {
      alert: number;
      reset: number;
    };
  };
}

interface FlowConfigHistoryProps {
  configId: string;
}

function getAlertsByType(history: (LowLevelAlert | FreezeAlert)[]) {
  const alertList: string[] = [];
  history.forEach((item) => {
    if ('temp' in item.config && item.config.temp?.alert) {
      alertList.push(item.id);
    }
    if ('cmLimit' in item.config && item.config.cmLimit) {
      alertList.push(item.id);
    }
  });
  return alertList;
}

export default function FlowConfigHistory({ configId }: FlowConfigHistoryProps) {
  const { history, isLoading } = useFlowConfigHistory(configId);

  if (isLoading) {
    return null;
  }

  if (history.length === 0) {
    return <div className="text-sm text-gray-600 p-2 bg-gray-50 rounded">Ingen historik</div>;
  }

  return (
    <Accordion type="single" collapsible className="w-full bg-white rounded-lg">
      <AccordionItem value="history" className="border-0">
        <AccordionTrigger className="py-3 px-4 hover:no-underline hover:bg-gray-50 rounded-lg">
          <div className="flex items-center gap-2">
            <History className="w-4 h-4 text-gray-500" />
            <span className="text-sm font-medium text-gray-700">Historik ({history.length})</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-4">
          <ul className="space-y-2 mt-2">
            {history.map((item) => (
              <li
                key={item.id}
                className="flex justify-between text-sm text-gray-600 p-2 bg-gray-50 rounded"
              >
                {/* Placeholder for history item - you'll define this later */}
                <div className="text-sm whitespace-pre-wrap">
                  {getExtendedAlertMessageString(item, item.type)}
                </div>
                <div className="text-xs text-gray-500">
                  {item.createTime.toLocaleString('da-DK')}
                </div>
              </li>
            ))}
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
